<template>
    <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :close-on-backdrop="false" :centered="false" :title="title" :size="'md'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
        <div class="px-3">
            <div class="row mx-0 px-0">
                <div class="mb-2 col-xl-12 px-1">
                    <label for="rol" class="mb-3">Banco</label>
                    <div class="input-group">
                      <div class="input-group-text">
                        <span style="font-size: 20px; border: none" class="input-group-text">
                          <i class="fa fa-address-book"></i>
                        </span>
                      </div>
                      <input type="text" class="form-control form-control-sm" name="name" v-model="data_detail.name" id="name"
                        placeholder="Banco" />
                    </div>
                </div>
                <div class="mb-2 col-xl-12 px-1">
                    <label for="rol" class="mb-3">N° Cuenta</label>
                    <div class="input-group">
                      <div class="input-group-text">
                        <span style="font-size: 20px; border: none" class="input-group-text">
                          <i class="fa fa-address-book"></i>
                        </span>
                      </div>
                      <input type="text" class="form-control form-control-sm" name="account_number" v-model="data_detail.account_number" id="account_number"
                        placeholder="N° Cuenta" />
                    </div>
                </div>
                <div class="mb-2 col-xl-12 px-1">
                    <label for="rol" class="mb-3">N° Cuenta Interbancaria</label>
                    <div class="input-group">
                      <div class="input-group-text">
                        <span style="font-size: 20px; border: none" class="input-group-text">
                          <i class="fa fa-address-book"></i>
                        </span>
                      </div>
                      <input type="text" class="form-control form-control-sm" name="inter_account_number" v-model="data_detail.inter_account_number" id="inter_account_number"
                        placeholder="N° Cuenta Interbancaria" />
                    </div>
                </div>
                <div class="mb-2 col-xl-12 px-1">
                    <label id="miSelect" for="name" class="form-label">Moneda</label>
                    <select v-model="data_detail.currency" class="form-control" aria-label=".form-select-sm example">
                        <option value="" disabled>Seleccione Moneda</option>
                        <option value="SOLES">SOLES</option>
                        <option value="DOLARES">DÓLARES</option>
                    </select>
                </div>
            </div>
            <div class="col-md-12 mt-3 pt-1" v-if="num === 1">
                <div class="form-check form-switch">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckChecked"
                        v-model="data_detail.state"
                        :checked="data_detail.state == 1 ? true : false"
                        aria-checked="false"
                    />
                    <label class="form-check-label" for="flexSwitchCheckChecked">
                        {{ data_detail.state == 1 ? 'Activo' : 'Inactivo' }}
                    </label>
                </div>
            </div>
        </div>
        <template #footer>
            <button class="btn btn-success btn-sm" @click="DataDetail" :disabled="cpButton">
                {{ (num == 0 ) ? 'Registrar':'Editar' }}
            </button>
            &nbsp;
        </template>
    </CModal>
</template>

<script>
import CModal from "../../shared/modals/CModal.vue";
import {
    mapActions
} from "vuex";

export default {
    name: "c-maintenance-modal-documento",
    components: {
        CModal,
    },
    data() {
        return {
            data_detail: {
                name: '',
                account_number: '',
                inter_account_number: '',
                currency: '',
                state: ''
            },
        };
    },
    watch: {
        payload: {
            handler(newVal) {
                if(this.num == 1){
                    if (newVal) {
                    this.data_detail = {
                        ...newVal
                    };
                }
                }
            },
            immediate: true,
        }
    },
    props: {
        title: String,
        boo_modal: Boolean,
        num: Number,
        payload: {
            type: Object,
            default: null
        }
    },
    computed: {
        cpButton() {
                return !(this.data_detail.name !='' && this.data_detail.account_number != null && this.data_detail.currency != null);
            
        }
    },
    methods: {
        ...mapActions(["get", "post"]),
        mtdClose() {
            this.data_detail.name ='';
            this.data_detail.account_number ='';
            this.data_detail.inter_account_number ='';
            this.data_detail.currency ='';
            this.data_detail.state ='';
            this.$emit("closeModal");
        },
        DataDetail() {
            this.$emit('Datadetail', this.data_detail, this.num)
            this.mtdClose();
        },
    },
    

};
</script>